import { render, staticRenderFns } from "./BatchGrantDialog.vue?vue&type=template&id=8e91e7ac&scoped=true"
import script from "./BatchGrantDialog.vue?vue&type=script&lang=js"
export * from "./BatchGrantDialog.vue?vue&type=script&lang=js"
import style0 from "./BatchGrantDialog.vue?vue&type=style&index=0&id=8e91e7ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e91e7ac",
  null
  
)

export default component.exports